export default __webpack_public_path__ + "static/media/phone.0c932e17.svg";